import { useTranslation } from '../i18n'
import { useApi } from '../hooks/useApi'
import type { VelocityMetrics } from '../types'

export function GlobalAvgEffort() {
  const { t } = useTranslation()
  const velocity = useApi<VelocityMetrics>('/dashboard/velocity')

  return (
    <div className="card" data-testid="global-avg-effort" style={{ marginTop: '1.5rem' }}>
      <h3>{t('component.globalAvgEffort')}</h3>
      <div className="stat-card" style={{ margin: '0.5rem 0' }}>
        <span className="stat-value">
          {velocity.loading || !velocity.data
            ? '--'
            : `${velocity.data.averageHoursPerTest.toFixed(1)} h`}
        </span>
        <span className="stat-label">{t('label.avgHoursPerTest')}</span>
      </div>
      <p style={{ fontSize: '0.875rem', color: '#666', marginTop: '0.5rem' }}>
        {t('misc.globalAvgHelp')}
      </p>
    </div>
  )
}
